import { Component, OnInit } from '@angular/core';

import { ThemeConfigService } from 'src/app/core/services/theme-config.service';
import { LocalStorageService } from 'ngx-webstorage';
import { GlobalVariableService } from '../../../../core/services/global-variable.service';
import { AppService } from '../../../../core/services/app.service';
import { AppConfigService } from '../../../../core/services/config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  typeView: any;
  user: any;
  response: any;
  constructor(
    private variable: GlobalVariableService,
    public themeConfig: ThemeConfigService,
    private storage: LocalStorageService,
    public configService: AppConfigService,
    private _app: AppService
  ) { }

  ngOnInit() {
    this.user = JSON.parse(this.variable.getUser());
    this.typeView = this.storage.retrieve('view');
    this.changeViewMode(this.typeView);
  }

  changeViewMode(type) {
    this.typeView = type;
    this.storage.store('view', type);
  }

}
